angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryPowerUnitsSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'powerUnits';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);